import { useEffect, useRef } from 'react';
import isEqual from 'lodash.isequal';
import { Order } from '@ads-bread/shared/bread/codecs';
import { useAuthentication } from '../../AuthenticationMachineContext';
import { ApplicationMachineActorRef } from '../ApplicationMachineContext';

type AuthenticationState = ReturnType<typeof useAuthentication>['state'];

/**
 * Emits events to the application machine based on changes to the order.
 * @param applicationService
 * @param order
 * @param authState
 */
export const useOrderUpdateEventEmitter = (
  applicationService: ApplicationMachineActorRef,
  order: Order,
  authState: AuthenticationState
): void => {
  const lastOrderRef = useRef<Order | undefined>(undefined);

  // Ensure we re-create application if order changes
  useEffect(() => {
    // Don't try to create an application if not authenticated.
    if (!authState.matches('authenticated')) {
      return;
    }

    const previousOrder = lastOrderRef.current;
    lastOrderRef.current = order;

    // Skip the initial render and no-op updates.
    if (!previousOrder || !order || isEqual(order, previousOrder)) {
      return;
    }

    applicationService.send({
      type: 'SEND_CREATE_APPLICATION',
      params: { context: applicationService.getSnapshot().context },
    });
  }, [order]);
};
